import React, { FC } from 'react';
import { Dispatch } from 'redux';
import { transition } from '../theme';
import {
  appViewUpdateIsDrawerOpen,
  getAppViewRelevantIsDrawerOpen,
} from '../app/store/appViewSlice';
import { connect } from 'react-redux';
import ArrowIcon from '@mui/icons-material/ArrowBackIos';
import { IconButton } from '@mui/material';
import { RootState } from '../store';

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

const AppDrawerToggle: FC<Props> = ({ isOpen, toggleIsOpen }) => {
  return (
    <IconButton
      color="primary"
      onClick={toggleIsOpen}
      sx={{
        opacity: 0.75,
        transition: transition(),
        padding: ({ spacing }) => spacing(0.5),
        position: 'absolute',
        background: ({ palette }) => palette.primaryLight80,
        left: ({ spacing }) => spacing(-1.5),
        bottom: ({ spacing }) => spacing(3),
        '&:hover': {
          background: ({ palette }) => palette.primaryLight80,
          opacity: 1,
        },
      }}
    >
      <ArrowIcon
        sx={{
          transition: transition({ duration: 0.5 }),
          transform: `translateX(${!isOpen ? 3 : -3}px) rotateZ(${!isOpen ? 0 : 180}deg)`,
          fontSize: '1rem',
        }}
      />
    </IconButton>
  );
};

const mapStateToProps = (state: RootState) => ({
  isOpen: getAppViewRelevantIsDrawerOpen(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  toggleIsOpen: () => dispatch(appViewUpdateIsDrawerOpen()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppDrawerToggle);
